export const PANEL_KEYS = {
  CAMPAIGN_NAME: 'campaign',
  LANGUAGE_TARGET: 'language-target',
  LOCATIONS: 'locations',
  AD_SCHEDULE: 'ad-schedule',
  BUDGET: 'budget',
  START_END_DATES: 'start-end-dates',
  SHORT_HEADLINES: 'headlines',
  DESCRIPTIONS: 'descriptions',
  IMAGES: 'images',
  AUDIENCE_SIGNAL: 'audience-signal',
  VIDEOS: 'videos',
  BID_STRATEGY: 'bid-strategy',
  BID_VALUE: 'bid-value',
  URL_OPTIONS: 'url-options',
  LOGOS: 'logos',
  FINAL_URL_EXPANSION: 'final-url-expansion',
  AUTO_GEN_ASSETS: 'auto-gen-assets',
  PAGE_FEEDS: 'page-feeds',
  CAMPAIGN_URL_OPTIONS: 'campaign-url-options',
  BRAND_EXCLUSIONS: 'brand-exclusions',
  COST_PER_SALE: 'cost_per_sale',
  SHOPPING: 'shopping-ads',
  CONVERSIONS: 'conversions',
  PRONG_IMAGES: 'prong-images',
  SPOTLIGHT_IMAGES: 'spotlight-images',
  NEW_CUSTOMER_ACQUISITION: 'new-customer-acquisition',
  APP: 'app',
  DISCLAIMERS: 'disclaimers',
  BRAND_SHOWROOM: 'brand-showroom',
  BRAND_SHOWROOM_COLORS: 'brand-showroom-colors',
};
